export default "__VITE_ASSET__Cvfirf$e__"